import React, {useMemo, useState} from "react";
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from '@components/custom/Search';
import moment from "moment";
import {IntervalOptions, Interval, SelectionMode} from "@models/index";
import {REGEX_PATTERNS} from "../../../../../constants/regex";
import __i18n from "../../../../../intl/__i18n";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
  intl: any;
}

const DiscountCodeUsesSearch: React.FC<SearchInputProps> = props => {
  const {search} = props;
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null);
  
  const defaultDisableRane = useMemo(() => [{
    disabled: true,
    start: moment().add(1, "d"),
    end: moment("3000/01/01")
  }] , []);
  
  const disabledEndDateRange = useMemo(() => {
    return startDate ? [{
      disabled: true,
      start: moment("1970/01/01"),
      end: moment(startDate).add(-1, "d")
    }, ...defaultDisableRane] : defaultDisableRane
  }, [startDate]);
  
  const inputs = [{
    name: "from",
    label: <FormattedMessage id="app.from" defaultMessage={`From`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      onChange: (date) => setStartDate(date),
      ranges:[{
        disabled: true,
        start: moment().add(1, "d"),
        end: endDate ? moment(endDate).add(-1, "d") : moment("3000/01/01")
      }]
    }
  }, {
    name: "to",
    label: <FormattedMessage id="app.to" defaultMessage={`To`}/>,
    type: SearchInputType.DATE,
    size: 8,
    InputProps:{
      onChange: (date) => setEndDate(date),
      disabled: startDate ? false : true,
      ranges: disabledEndDateRange
    }
  },{
    name: "msisdn",
    label: <FormattedMessage id="app.mobile" defaultMessage={`Mobile`}/>,
    size: 8,
    type: SearchInputType.TEXT,
    validationRules:[{
      pattern: REGEX_PATTERNS.MOBILE,
      message: __i18n("{value} is not valid.", {
        value : __i18n("Value")
      })
    }],
    InputProps:{
      placeholder : "98912111111"
    }
  }];
  
  return(
    <Search
      inputs={inputs}
      search={search}
      hasClearButton={true}
      searchOnChange={false}/>
  )
};


export default DiscountCodeUsesSearch;